
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WorkOrderBOMGrid extends Serenity.EntityGrid<WorkOrderBOMRow, any> {
        protected getColumnsKey() { return 'Production.WorkOrderBOM'; }
        protected getDialogType() { return WorkOrderBOMDialog; }
        protected getIdProperty() { return WorkOrderBOMRow.idProperty; }
        protected getInsertPermission() { return WorkOrderBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return WorkOrderBOMRow.localTextPrefix; }
        protected getService() { return WorkOrderBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}